import type { SVGProps } from 'react';
const SvgIconCheckSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.57 4.73a.75.75 0 0 1 0 1.06l-5.48 5.48a.75.75 0 0 1-1.06 0L3.67 7.91a.75.75 0 0 1 1.06-1.06l2.83 2.33 4.95-4.45a.75.75 0 0 1 1.06 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconCheckSmall;
